import { ref } from 'vue';
import { message } from 'ant-design-vue';
import { getFileName, getFileType } from '@/utils/utils';
import { batchMoveFile } from '../../methods';
import { useRefHooks } from '../../../../utils/hooks';
import EventBus from '@/controller/EventBus';

export const DragTips = {
  sameNameTips: {
    label: '同名的音频和字幕会一起移动到文件夹内噢',
    value: 'sameNameTips',
  },
  deepColumnTips: {
    label: '暂不支持多级文件夹移动',
    value: 'deepColumnTips',
  },
  dropSameColumnTips: {
    label: '无法拖入选中的文件夹中',
    value: 'dropSameColumnTips',
  },
};
export default function handleDrop(props, emit) {
  let isDragFolderOrFile;
  EventBus.setCanDragUpload.addEventLister('cannotDragUpload', value => {
    isDragFolderOrFile = value;
  });
  const hoverClass = ref('');
  const [showDragTipModal, setShowDragTipModal] = useRefHooks(false);
  const dragTipsContent = ref({});
  // 要进入的文件夹存在同名文件不能移动（移动的文件含lrc，但同名的mp3没有lrc时，lrc也不让移动）
  function getCanDropData(data) {
    console.log('zxx--getCanDropData--', data);
    const repeatName = [];
    if (!data) {
      return [];
    }
    data.forEach(item => {
      if (getFileType(item.title)) {
        const fileData = props.articleList.find(
          file => getFileName(file.title) === getFileName(item.title)
        );
        if (fileData) {
          // 有同名音频
          repeatName.push(getFileName(item.title));
        }
      }
    });
    const newData = data.filter(file => !(repeatName.indexOf(getFileName(file.title)) > -1));
    if (newData.length !== data.length) {
      message.error({ content: '文件夹中存在同名文件' });
    }
    return newData;
  }
  function checkCanMove(data) {
    if (data.hasDeepColumn) {
      setShowDragTipModal(true);
      dragTipsContent.value = DragTips.deepColumnTips;
      return false;
    }
    const moveSelf = data.columnKeyList?.find(column => column.key === props.columnKey);
    if (moveSelf) {
      setShowDragTipModal(true);
      dragTipsContent.value = DragTips.dropSameColumnTips;
      return false;
    }
    return true;
  }
  function drop(data) {
    if (!isDragFolderOrFile) {
      // 不是项目内拖拽文件（是系统拖拽上传文件）
      return;
    }
    const moveData = getCanDropData(data.articleKeyList) || [];
    const canMove = checkCanMove(data);
    if (!canMove || (moveData.length === 0 && data.columnKeyList?.length === 0)) return;

    batchMoveFile({
      newColumnKey: props.columnKey,
      oldColumnKey: data.columnKey,
      articleKeyList: JSON.stringify(moveData),
      columnKeyList: JSON.stringify(data.columnKeyList),
    }).then(
      res => {
        if (res.code === 0) {
          emit('update');
          if (data.hasCouple) {
            // 显示提示弹框
            setShowDragTipModal(true);
            dragTipsContent.value = DragTips.sameNameTips;
          }
        }
      },
      () => {}
    );
  }
  function dragover() {
    hoverClass.value = 'folder-hover';
  }
  function dragleave() {
    hoverClass.value = '';
  }
  return {
    drop,
    hoverClass,
    dragover,
    dragleave,
    showDragTipModal,
    setShowDragTipModal,
    dragTipsContent,
  };
}
